// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__-yKb3","left":"InfoRow_left__1aGbp"};